import tippy from 'tippy.js';
import 'lazysizes';
import './bugsnag';
import './asset-loaders';
import './global';
import './session';
import './ui-helpers';
import './polyfills';
import '../apps/navigation';
import loadFormEnhancements from 'shared/form-enhancements';
import InterNACHI from "shared/InterNACHI.js";
import route from 'shared/ziggy.js';
import { mark } from 'shared/user-timing';

mark('Boot started');

// Lazy load some parts
import('./bootstrap-plugins.js' /* webpackChunkName: "achunk~bootstrap-plugins" */);

// Add globals
window.tippy = tippy;
window.route = route;

// Kept around for backwards-compatibility for now
let formEnhancementsLoaded = false;
window.ensure = (part) => {
	if ('form-enhancements' !== part) {
		return Promise.reject(`Unknown part: "${ part }"`);
	}
	
	if (true === formEnhancementsLoaded) {
		return Promise.resolve(jQuery);
	}
	
	jQuery.holdReady(true);
	
	return loadFormEnhancements()
		.then(() => {
			formEnhancementsLoaded = true;
			jQuery.holdReady(false);
			return jQuery;
		});
};

jQuery(function($) {
	const $html = $('html');
	
	$html.removeClass('no-js').addClass('has-js');
	
	InterNACHI.session.onGuest(() => {
		$html.addClass('logged-out').removeClass(['logged-in', 'authenticating']);
	});
	
	InterNACHI.session.onLoaded(() => {
		$html.addClass('logged-in').removeClass(['logged-out', 'authenticating']);
	});
	
	tippy('[data-tippy-content]');
	mark('Boot jQuery DOMContentReady');
});
